import 'react-multi-carousel/lib/styles.css';

import ImageCarousel from './ImageCarousel';
import type { ImageCarouselImage } from './types';

export default ImageCarousel;
export type { ImageCarouselImage };
